"use client";

import { Card, ProgressBar, Row, Col, Form, Button } from "react-bootstrap";
import { useState, useMemo } from "react";

const Channels = ({ data = [], onRangeChange }) => {
  const [range, setRange] = useState("daily");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // 🔹 Pagination calculation
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  }, [data, currentPage]);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  if (!data.length) return null;

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <Row className="align-items-center mb-3">
          <Col>
            <h3 className="mb-0">Used Apps List</h3>
          </Col>
          <Col sm="auto">
            <Form.Select
              value={range}
              onChange={(e) => {
                setRange(e.target.value);
                setCurrentPage(1);
                if (onRangeChange) onRangeChange(e.target.value);
              }}
              size="sm"
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </Form.Select>
          </Col>
        </Row>

        <ul className="ps-0 mb-0 list-unstyled list-last-child">
          {paginatedData.map((app, index) => (
            <li key={index} className="mb-3 pb-3 border-bottom">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div style={{ width: "120px" }}>
                    <ProgressBar
                      now={Math.min(Math.round((app.total_seconds / 3600) * 10), 100)}
                      style={{
                        height: "8px",
                        backgroundColor: "#DDE4FF",
                      }}
                    />
                  </div>
                  <div className="ms-3">
                    <h4 className="mb-0 fs-14 fw-semibold lh-1">{app.app_name}</h4>
                    <span className="fs-12 text-muted">{app.window_title || "-"}</span>
                  </div>
                </div>
                <div className="text-end">
                  <span className="count text-body fs-12">
                    {Math.floor(app.total_seconds / 60)} min
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-between mt-3">
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Previous
            </Button>
            <span className="align-self-center fs-12">
              Page {currentPage} of {totalPages}
            </span>
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default Channels;